/* eslint-disable no-param-reassign */
import request from './request';

const SELECTORS = {
  WRAPPER: '.js-preview-cart',
  FIELD: '.js-preview-cart-field',
};

const URL = '/ajax/updateCart.php';
const ERROR_MESSAGE = 'Произошла ошибка при обновлении корзины товаров';

const updateCart = async () => {
  const previewCart = document.querySelector(SELECTORS.WRAPPER);
  const allPreviewCarts = document.querySelectorAll(SELECTORS.WRAPPER);
  const previewCartField = previewCart && previewCart.querySelector(SELECTORS.FIELD);
  if (!previewCartField) {
    return;
  }
  try {
    const formData = new FormData();
    formData.append('data', previewCartField.value);
    const response = await request(URL, 'POST', formData);
    const newCartHtml = await response.text();
    allPreviewCarts.forEach((elem) => {
      elem.innerHTML = newCartHtml;
    });
  } catch (error) {
    alert(ERROR_MESSAGE);
    console.error(error);
  }
};
export default updateCart;
